<template>
    <div class="temp-content">
        <!-- 新增按钮 -->
        <div class="action-button">
            <t-button theme="primary" @click="addClick">
                <template #icon><add-icon /></template>
                新增
            </t-button>
        </div>

        <!-- 列表区域 -->
        <t-table
            :data="categoryData" 
            :columns="columns"
            table-layout="fixed"
            :show-header="true"
            cell-empty-content="--"
            row-key="index"
            resizable
            lazy-load
            size="large"
            bordered
            hover
            @drag-sort="onDragSort"
            drag-sort="row-handler"
        >
            <template #drag>
                <span><MoveIcon /></span>
            </template>

            <template #orderNumber="{ rowIndex }">
                {{ rowIndex + 1 }}
            </template>

            <template #categoryName="{ row }">
                <div class="category-name-wrap"> 
                    <img class="category-image" :src="row.categoryImage" alt=""  />
                    <div class="category-name">{{ row.name }}</div>
                </div>
            </template>

            <!--启用状态-->
            <template #isActive="{ row }">
                <span :class="{ 'status-inactive': row.isActive === '已停用' }">
                    {{ row.isActive }}
                </span>
            </template>

            <template #action="{ row }">
                <div class="table-action">
                    <t-link
                        class="edit-action"
                        theme="primary"
                        hover="color"
                        @click="editClick(row)"
                    >
                        编辑
                    </t-link>

                    <t-link
                        class="status-action"
                        theme='primary'
                        hover="color"
                        @click="switchStatus(row)"
                    >
                        {{ row.isActive === '已启用' ? '停用' : '启用' }}
                    </t-link>

                    <t-link
                        class="delete-action"
                        v-if="row.isActive === '已停用'"
                        theme="danger"
                        hover="color"
                        @click="deleteItem(row)"
                    >
                        删除
                    </t-link>
                </div>
            </template>
        </t-table>

        <!-- 抽屉-新增分类 -->
        <t-drawer
            class="add-drawer"
            v-model:visible="addDrawerVisible"
            header="新增分类" 
            size="800px"
        >
            <div class="form-wrap">
                <!-- 分类名称 -->
                <div class="form-item">
                    <div class="form-item-name">分类名称</div>
                    <div class="form-element">
                        <t-input
                            v-model="addCategoryData.name"
                            placeholder="请输入分类名称"
                            :maxlength="8"
                            show-limit-number
                            clearable
                            size="large"
                        />
                    </div>
                </div>

                <!-- 分类图片 -->
                <div class="form-item">
                    <div class="form-item-name">分类图片</div>
                    <div class="form-element">
                        <t-upload
                            v-model="addCategoryData.image"
                            theme="image"
                            accept="image/*"
                            :auto-upload="false"
                            :max="1"
                            :showImageFileName="false"
                            :size-limit="sizeLimit"
                            tips="建议尺寸120px*120px，最大不超过500k"
                            @success="(res, file) => onUploadSuccess(res, file, 'add')"
                            @fail="(res, file) => onUploadFail(res, file, 'add')"
                            
                        />
                    </div>
                </div>

                <!-- 营地类型 -->
                <div class="form-item">
                    <div class="form-item-name">营地类型</div>
                    <div class="form-element">
                        <t-select
                            v-model="addCategoryData.camp_type_id"
                            :options="campTypeList"
                            multiple
                            filterable
                            clearable
                            placeholder="请选择"
                            size="large"
                        />          
                    </div>
                </div>
                            
                <!-- 排序 -->
                <div class="form-item">
                    <div class="form-item-name">排序</div>
                    <div class="number-form-element">
                        <t-input-number
                            v-model="addCategoryData.order"
                            :max="9999"
                            :min="1"
                            size="large" 
                        />             
                    </div>
                </div>
            </div>

            <template #footer>
                <t-button
                    theme="primary"
                    @click="submitAddCategory"
                    :loading="isSubmitting"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? '提交中' : '确定' }}
                </t-button>
                <t-button theme="default" @click="addDrawerVisible = false">取消</t-button>
            </template>
        </t-drawer>

        <!-- 抽屉-编辑分类 -->
        <t-drawer
            class="edit-drawer"
            v-model:visible="editDrawerVisible"
            header="编辑分类" 
            size="800px"
        >
            <div class="form-wrap">
                <!-- 分类名称 -->
                <div class="form-item">
                    <div class="form-item-name">分类名称</div>
                    <div class="form-element">
                        <t-input
                            v-model="editCategoryData.name"
                            placeholder="请输入分类名称"
                            :maxlength="8"
                            show-limit-number
                            clearable
                            size="large"
                        />
                    </div>
                </div>

                <!-- 分类图片 -->
                <div class="form-item">
                    <div class="form-item-name">分类图片</div>
                    <div class="form-element">
                        <t-upload
                            v-model="editCategoryData.image"
                            theme="image"
                            accept="image/*"
                            :auto-upload="false"
                            :max="1"
                            :showImageFileName="false"
                            :size-limit="sizeLimit"
                            tips="建议尺寸120px*120px，最大不超过500k"
                            @success="(res, file) => onUploadSuccess(res, file, 'add')"
                            @fail="(res, file) => onUploadFail(res, file, 'add')"
                            :before-upload="beforeUpload"
                        />
                    </div>
                </div>

                <!-- 营地类型 -->
                <div class="form-item">
                    <div class="form-item-name">营地类型</div>
                    <div class="form-element">
                        <t-select
                            v-model="editCategoryData.camp_type_id"
                            :options="campTypeList"
                            multiple
                            filterable
                            clearable
                            placeholder="请选择"
                            size="large"
                        />          
                    </div>
                </div>
                            
                <!-- 排序 -->
                <div class="form-item">
                    <div class="form-item-name">排序</div>
                    <div class="number-form-element">
                        <t-input-number
                            v-model="editCategoryData.order"
                            :max="9999"
                            :min="1"
                            size="large" 
                        />             
                    </div>
                </div>
            </div>

            <template #footer>
                <t-button theme="primary" @click="submitEditCategory">确定</t-button>
                <t-button theme="default" @click="editDrawerVisible = false">取消</t-button>
            </template>
        </t-drawer>
    </div>
</template>

<script setup lang="jsx">
    import { AddIcon, MoveIcon } from 'tdesign-icons-vue-next';
    import { ref, onMounted } from 'vue';
    import categoryAPI from '../../../api/category-api';
    import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
    import { formatTime } from '../../../utils/datetime';

    // 数据初始化
    const categoryData = ref([]);
    const campTypeList = ref([]);

    /**
     * 表格列定义
     */
    const columns = ref([
        { colKey: 'drag', title: '', width: '48' },
        { colKey: 'orderNumber', title: '序号', width: '72' },
        { colKey: 'categoryName', title: '分类名称' },
        { colKey: 'categoryNumber', title: '营地数量',width: '100' },
        { colKey: 'campType', title: '类型' },
        { colKey: 'isActive', title: '状态' },
        { colKey: 'updateTime', title: '修改时间' },
        { colKey: 'updateBy', title: '修改人' },
        { colKey: 'action', title: '操作', width: 180 },
    ]);

    /**
     * 获取分类列表
     */
    const getCategoryList = async () => {
        try {
            const response = await categoryAPI.getCategoryList();
            //console.log('分类列表数据:', response);
            
            if (response && response.category_data && Array.isArray(response.category_data)) {
                categoryData.value = response.category_data.map((item, index) => ({
                    id: item.id,
                    name: item.name,
                    categoryImage: item.image,
                    campType: item.camp_type_name,
                    categoryNumber: item.category_number,
                    isActive: item.is_active ?'已启用':'已停用',
                    order: item.order,
                    updateTime:formatTime(item.update_time),
                    updateBy: item.update_by,
                    orderNumber: index + 1
            }));

            // 计算最大排序值
            const maxOrder = Math.max(...categoryData.value.map(item => item.order), 0);
            addCategoryData.value.order = maxOrder + 1;

            } else {
                MessagePlugin.error('获取分类失败：数据格式错误');
            }
        } catch (error) {
            console.error('获取分类列表失败', error);
            MessagePlugin.error('获取分类列表失败: ' + error.message);
        }
    };


    // 获取营地类型列表
    const getCampTypeList = async () => {
        
        try {
            const result = await categoryAPI.getCampType();
            campTypeList.value = result.map(type => ({
                label: type.name,
                value: type.id
            }));
        } catch (error) {
            console.error('获取营地类型失败', error);
        }
    };
    

    // 生命周期钩子
    onMounted(() => {
        getCategoryList();
        getCampTypeList();
    });


    // 抽屉可见性状态
    const addDrawerVisible = ref(false);
    const editDrawerVisible = ref(false);

    /**
     * 图片上传处理
     */
     const sizeLimit = ref(500 * 1024);
    // 图片上传前的验证
    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        const isLt500k = file.size <= sizeLimit.value;

        if (!isImage) {
            MessagePlugin.error('仅支持上传图片文件');
            return false;
        }
        if (!isLt500k) {
            MessagePlugin.error('图片大小不能超过500k');
            return false;
        }
        return true;
    };

    // 图片上传成功处理
    const onUploadSuccess = (response, file, type = 'add') => {
        const imageUrl = response.url || file.url || URL.createObjectURL(file.raw);
        if (imageUrl) {
            const imageData = [{ url: imageUrl, raw: file.raw, name: file.name }];
            if (type === 'add') {
                addCategoryData.value.image = imageData;
            } else {
                editCategoryData.value.image = imageData;
            }
            console.log('Image uploaded successfully:', imageUrl);
            MessagePlugin.success('图片上传成功');
        } else {
            console.error('无法获取上传图片的URL', response, file);
            MessagePlugin.error('图片上传失败，请重试');
        }
    };
    // 图片上传失败处理
    const onUploadFail = (response, file, type = 'add') => {
        console.error('图片上传失败:', response);
        MessagePlugin.error('图片上传失败，请重试');
        if (type === 'add') {
            addCategoryData.value.image = [];
        } else {
            editCategoryData.value.image = [];
        }
    };

    // 分类最大数量
    const maxCategoryNumer = 50
    /**
     * 新增按钮跳转
    */ 
    const addClick = () => {
        if (categoryData.value.length >= maxCategoryNumer) {
        MessagePlugin.warning(`最多添加${maxCategoryNumer}个`);
        return;
        }
        addCategoryData.value = {
            name: '',
            image: [],
            camp_type_id: [],
            order: Math.max(...categoryData.value.map(item => item.order), 0) + 1
        };
        addDrawerVisible.value = true;
    };

    // 新增分类初始数据
    const addCategoryData = ref({
        name: '',
        image: [],
        camp_type_id: [],
        order: 1
    });


    // 验证新增分类表单
    const validateAddCategory = () => {
        if (!addCategoryData.value.name) {
            MessagePlugin.warning('请输入分类名称');
            return false;
        }
        if (!addCategoryData.value.image || addCategoryData.value.image.length === 0) {
            MessagePlugin.warning('请上传分类图片');
            return false;
        }
        if (addCategoryData.value.camp_type_id.length === 0) {
            MessagePlugin.warning('请选择营地类型');
            return false;
        }
        return true;
    };

    // 按钮提交中
    const isSubmitting = ref(false);

    // 提交新增分类
    const submitAddCategory = async () => {
        if (isSubmitting.value) {
            return; // 如果正在提交，直接返回
        }

        if (!validateAddCategory()) {
            return;
        }

        try {
            isSubmitting.value = true;
            const formData = new FormData();
            formData.append('name', addCategoryData.value.name);
            formData.append('order', addCategoryData.value.order.toString());
            formData.append('camp_type_id', JSON.stringify(addCategoryData.value.camp_type_id));
            formData.append('is_active', 'true');
            formData.append('update_by', 'admin');

            if (addCategoryData.value.image && addCategoryData.value.image.length > 0 && addCategoryData.value.image[0].raw) {
                formData.append('image', addCategoryData.value.image[0].raw, addCategoryData.value.image[0].name);
            }

            await categoryAPI.createCategory(formData);

            MessagePlugin.success('新增分类成功');
            // 关闭抽屉
            addDrawerVisible.value = false;
            // 刷新分类列表
            await getCategoryList(); 
            // 重置表单数据
            addCategoryData.value = {
                name: '',
                image: [],
                camp_type_id: [],
                order: 1
            };
        } catch (error) {
            console.error('新增失败', error);
            MessagePlugin.error('新增失败: ' + (error.response?.data?.message || error.message));
        }finally {
            // 2秒后重置提交状态
            setTimeout(() => {
                isSubmitting.value = false;
            }, 2000);
        }
    };

    // 编辑分类初始数据
    const editCategoryData = ref({
        id: null,
        name: '',
        image: [],
        camp_type_id: [], // 改为 camp_type_id 以匹配新增功能
        order: 1
    });

    /**
     * 编辑按钮跳转
     */
    const editClick = (row) => {
        editCategoryData.value = {
            id: row.id,
            name: row.name,
            image: row.categoryImage ? [{ url: row.categoryImage }] : [],
            camp_type_id: row.campType ? row.campType.split(', ').map(type => {
                const foundType = campTypeList.value.find(ct => ct.label === type);
                return foundType ? foundType.value : null;
            }).filter(id => id !== null) : [],
            order: row.order
        };
        editDrawerVisible.value = true;
    };

    // 编辑分类验证
    const validateEditCategory = () => {
        if (!editCategoryData.value.name) {
            MessagePlugin.warning('请输入分类名称');
            return false;
        }
        if (!editCategoryData.value.image || editCategoryData.value.image.length === 0) {
            MessagePlugin.warning('请上传分类图片');
            return false;
        }
        if (editCategoryData.value.camp_type_id.length === 0) {
            MessagePlugin.warning('请选择营地类型');
            return false;
        }
        return true;
    };

    /**
     * 提交编辑分类
     */
    const submitEditCategory = async () => {
    if (!validateEditCategory()) {
        return;
    }
    try {
        const formData = new FormData();
        formData.append('name', editCategoryData.value.name);
        formData.append('order', editCategoryData.value.order.toString());
        formData.append('camp_type_id', JSON.stringify(editCategoryData.value.camp_type_id));
        formData.append('update_by', 'admin');

        if (editCategoryData.value.image && editCategoryData.value.image.length > 0) {
            if (editCategoryData.value.image[0].raw) {
                formData.append('image', editCategoryData.value.image[0].raw, editCategoryData.value.image[0].name);
            } else {
                formData.append('image', editCategoryData.value.image[0].url);
            }
        }

        await categoryAPI.updateCategory(editCategoryData.value.id, formData);
        
        MessagePlugin.success('编辑分类成功');
        editDrawerVisible.value = false; // 关闭抽屉
        await getCategoryList(); // 刷新列表
    } catch (error) {
        console.error('编辑分类失败', error);
        MessagePlugin.error('编辑失败: ' + (error.response?.data?.message || error.message));
    }
};

    /**
     * 修改状态
     */
    const switchStatus = (row) => {
        const newStatus = row.isActive === '已停用';
        const actionText = newStatus ? '启用' : '停用';

        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: `确定${actionText}分类 "${row.name}" 吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            onConfirm: async () => {
                try {
                    // 调用 API
                    await categoryAPI.updateCategoryStatus(row.id, newStatus);
                   
                    // 更新本地数据
                    row.isActive = newStatus ? '已启用' : '已停用';

                    // 强制更新视图
                    categoryData.value = [...categoryData.value];

                    // 注销弹窗
                    dialog.destroy();
                    MessagePlugin.success(`分类已${actionText}`);
                    } catch (error) {
                        console.error('修改状态失败:', error);
                        MessagePlugin.error(`${actionText}失败，请重试`);
                    }
                },
            });
    };  


    /**
     * 删除分类
     */
    const deleteItem = (row) => {
        const dialog=DialogPlugin.confirm({
            header: '提示',
            body: `确定要删除分类 "${row.name}" 吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            onConfirm: async () => {
                try {
                    await categoryAPI.deleteCategory(row.id);
                    MessagePlugin.success('删除成功');
                    dialog.destroy();
                    await getCategoryList(); // 刷新列表
                } catch (error) {
                    MessagePlugin.error('删除失败: ' + (error.response?.data?.message || error.message));
                }
            }
        })
    };

    /**
     * 拖动排序
    */
    const onDragSort = async ({ newData, oldIndex, newIndex }) => {
        const reorderData = newData.map((item, index) => ({
            id: item.id,
            order: index + 1,
        }));

        // 更新本地数据
        categoryData.value = newData; 

        try {
            await categoryAPI.reorderCategory(reorderData);
            MessagePlugin.success('排序更新成功');
        } catch (error) {
            MessagePlugin.error(`排序更新失败: ${error.message}`);
            await getCategoryList(); // 失败时回滚
        }
    };

</script>

<style scoped>
@import "./category-admin.css";
@import "../../../components/style/style-table.css";
@import "../../../components/style/style-drawer.css";
</style>